import OptoLogo from '../assets/Opto'

const opto = {
  getImage: (props) => <OptoLogo className="opto newLogo" {...props} />,
  getURL: (variant) => 'https://www.optoinvest.com/',
}

export default opto
